/**
 * Desktop-safe JSON helper.
 *
 * In Electron, this routes through the main process to avoid renderer CORS
 * issues from the `app://` origin. In web, it falls back to normal fetch.
 *
 * @example
 * await fetchJsonDesktopSafe("https://api.example.com/externalauth/gong/auth_url");
 * // { auth_url: "https://app.gong.io/oauth/authorize?..." }
 *
 * @example
 * await fetchJsonDesktopSafe("https://api.example.com/externalauth/gong/callback", {
 *   method: "POST",
 *   body: { code: "abc", state: "business_gong_popup_desktop" },
 * });
 * // { credential_id: "cred_1" }
 */
export const fetchJsonDesktopSafe = async (url, fetchInit = {}) => {
  const target = String(url || "").trim();
  if (!target) {
    throw new Error("Missing URL");
  }

  const method = String(fetchInit.method || "GET").toUpperCase();
  const body = fetchInit.body;
  const desktopFetcher = window.starmeshDesktop?.desktopFetchJson;
  if (window.starmeshDesktop?.isElectron && typeof desktopFetcher === "function") {
    return desktopFetcher(target, { method, body });
  }

  const response = await fetch(target, {
    credentials: "include",
    method,
    headers:
      method === "GET"
        ? { Accept: "application/json" }
        : { Accept: "application/json", "Content-Type": "application/json" },
    ...(body !== undefined && method !== "GET"
      ? { body: typeof body === "string" ? body : JSON.stringify(body) }
      : {}),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(
      String(data?.error || data?.message || "").trim() ||
        `Request failed (${response.status})`
    );
  }
  return data;
};

